// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //urlApi: 'http://10.100.10.54:3200/cafe'
  //urlApi: 'http://10.100.10.30:5010/cafe'
  //urlApi: 'http://3.137.202.147:5010/cafe'
  urlApi: 'https://lacafe.granjazul.com/cafe'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
